module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./PhoneVerifyView.js"));
	}, "PhoneVerifyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PhoneVerifyView!./src/pages/Shop/Member/Personal/Account/PhoneVerify/PhoneVerifyView.js
// module id = 992
// module chunks = 431